import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import Select from 'react-select'
import GlobalHelper from "../GlobalHelper.jsx"
const Countries = require("i18n-iso-countries")
Countries.registerLocale(require("i18n-iso-countries/langs/en.json"))
Countries.registerLocale(require("i18n-iso-countries/langs/fr.json"))
Countries.registerLocale(require("i18n-iso-countries/langs/nl.json"))

class CountrySelect extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            options: [],
            firstCountries: ['US', 'CA', 'AU', 'GB'],
            countryCode: this.props.countryCode || '',
            disabled: this.props.disabled || false,
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption ? selectedOption.value : ''
        }, () => {
            this.onChange(this.state.selectedOption, selectedOption ? selectedOption.code : '')
        });
    }

    loadCountries() {
        const locale = AppContext.getLocale().getLanguageWithoutRegionCode()
        const options = []
        const countries = GlobalHelper.getCountries(locale)
        let selectedOption = ''
        for (let i in this.state.firstCountries) {
            const code = this.state.firstCountries[i]
            options.push({
                value: countries[code],
                label: countries[code],
                code: code,
            })
        }
        for (let code in countries) {
            if (!this.state.firstCountries.includes(code)) {
                options.push({
                    value: countries[code],
                    label: countries[code],
                    code: code,
                })
            }
            if (this.state.countryCode == code) {
                selectedOption = countries[code]
            }
        }
        this.setState({
            options: options,
            selectedOption: selectedOption || null,
        })
    }

    componentDidMount() {
        this.loadCountries()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            selectedOption: GlobalHelper.getCountryLocalizedName(nextProps.countryCode, AppContext.getLocale().getLanguageWithoutRegionCode()) || null,
            countryCode: nextProps.countryCode || '',
            disabled: nextProps.disabled || false,
        })
    }

    render() {
        return (
            <Select
                name={this.name}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.options}
                disabled={this.state.disabled}
            />
        )
    }
}

export default CountrySelect





// WEBPACK FOOTER //
// ./src/common/contact/countryselector.component.jsx